 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili":"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili","agricoltori~convenzioni~not_available~report~tecnici":"agricoltori~convenzioni~not_available~report~tecnici","agricoltori":"agricoltori","convenzioni":"convenzioni","not_available":"not_available","report":"report","tecnici":"tecnici","aziende":"aziende","magazzino":"magazzino","unita_mobili":"unita_mobili","avvisi~settings":"avvisi~settings","avvisi":"avvisi","maps~prenotazioni_advanced~prenotazioni_calendar":"maps~prenotazioni_advanced~prenotazioni_calendar","maps":"maps","prenotazioni_advanced":"prenotazioni_advanced","prenotazioni_calendar~settings":"prenotazioni_calendar~settings","prenotazioni_calendar":"prenotazioni_calendar","settings":"settings","reset_password":"reset_password","statistiche":"statistiche","vue-cropperjs":"vue-cropperjs"}[chunkId]||chunkId) + "." + {"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili":"b722f217","agricoltori~convenzioni~not_available~report~tecnici":"39b8d633","agricoltori":"494ed679","convenzioni":"6c48c329","not_available":"19201cbf","report":"d0ddc8b0","tecnici":"d1e8ac1a","aziende":"9bfae1d8","magazzino":"1afc1e71","unita_mobili":"1dc855f1","avvisi~settings":"e6cfef93","avvisi":"3d39e9e1","maps~prenotazioni_advanced~prenotazioni_calendar":"f019a5dd","maps":"e111c5c6","prenotazioni_advanced":"6fc221d1","prenotazioni_calendar~settings":"5081ece9","prenotazioni_calendar":"e0f97baf","settings":"cf2f8efb","reset_password":"3bbe1448","statistiche":"f84601a0","vue-cropperjs":"99d0d32e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili":1,"agricoltori~convenzioni~not_available~report~tecnici":1,"agricoltori":1,"convenzioni":1,"not_available":1,"report":1,"tecnici":1,"magazzino":1,"unita_mobili":1,"avvisi~settings":1,"avvisi":1,"maps~prenotazioni_advanced~prenotazioni_calendar":1,"maps":1,"prenotazioni_advanced":1,"prenotazioni_calendar":1,"settings":1,"reset_password":1,"statistiche":1,"vue-cropperjs":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili":"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili","agricoltori~convenzioni~not_available~report~tecnici":"agricoltori~convenzioni~not_available~report~tecnici","agricoltori":"agricoltori","convenzioni":"convenzioni","not_available":"not_available","report":"report","tecnici":"tecnici","aziende":"aziende","magazzino":"magazzino","unita_mobili":"unita_mobili","avvisi~settings":"avvisi~settings","avvisi":"avvisi","maps~prenotazioni_advanced~prenotazioni_calendar":"maps~prenotazioni_advanced~prenotazioni_calendar","maps":"maps","prenotazioni_advanced":"prenotazioni_advanced","prenotazioni_calendar~settings":"prenotazioni_calendar~settings","prenotazioni_calendar":"prenotazioni_calendar","settings":"settings","reset_password":"reset_password","statistiche":"statistiche","vue-cropperjs":"vue-cropperjs"}[chunkId]||chunkId) + "." + {"agricoltori~aziende~convenzioni~magazzino~not_available~report~tecnici~unita_mobili":"46bd4096","agricoltori~convenzioni~not_available~report~tecnici":"1c3666a4","agricoltori":"10574ab3","convenzioni":"10574ab3","not_available":"0cd9ddc2","report":"6580698a","tecnici":"10574ab3","aziende":"31d6cfe0","magazzino":"c0478d5b","unita_mobili":"74ffc3bf","avvisi~settings":"ace865b2","avvisi":"c015b2a4","maps~prenotazioni_advanced~prenotazioni_calendar":"4773bb33","maps":"6a14bfbc","prenotazioni_advanced":"05e5517d","prenotazioni_calendar~settings":"31d6cfe0","prenotazioni_calendar":"4c08b70f","settings":"7f3919a1","reset_password":"9eb04912","statistiche":"bd671982","vue-cropperjs":"db150903"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/bew/portal/v1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
